import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { useForm } from 'react-hook-form';
import { toast } from 'react-toastify';
import { ContactForm } from '../types';
import './Contact.css';

const Contact: React.FC = () => {
  const [isSubmitting, setIsSubmitting] = useState<boolean>(false);
  const { register, handleSubmit, formState: { errors }, reset } = useForm<ContactForm>();

  const onSubmit = async (data: ContactForm) => {
    setIsSubmitting(true);
    try {
      // Simulate API call
      await new Promise(resolve => setTimeout(resolve, 1000));
      toast.success('Message sent successfully! I\'ll get back to you soon.');
      reset();
    } catch (error) {
      toast.error('Failed to send message. Please try again.');
    } finally {
      setIsSubmitting(false);
    }
  };

  const socialLinks = [
    { name: 'GitHub', url: 'https://github.com/andy3400', icon: '💻' },
    { name: 'Blog', url: 'https://velog.io/@andy3400', icon: '📝' },
    { name: 'LinkedIn', url: 'https://linkedin.com/in/taehogu/', icon: '💼' }
  ];

  return (
    <div className="contact">
      {/* Contact Header */}
      <section className="contact-header">
        <div className="container">
          <motion.div
            className="contact-hero"
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
          >
            <h1>Contact here</h1>
            <div className="contact-info">
              <div className="info-item">
                <span className="label">Name</span>
                <span className="value">이태호 (Taeho Lee)</span>
              </div>
              <div className="info-item">
                <span className="label">Email</span>
                <span className="value">grayhat3400@gmail.com</span>
              </div>
              <div className="info-item">
                <span className="label">GitHub</span>
                <span className="value">github.com/andy3400</span>
              </div>
              <div className="info-item">
                <span className="label">Blog</span>
                <span className="value">velog.io/@andy3400</span>
              </div>
            </div>
          </motion.div>
        </div>
      </section>

      {/* Contact Form */}
      <section className="contact-form-section">
        <div className="container">
          <motion.div
            className="form-container"
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
          >
            <h2>Have a project idea?</h2>
            <p>just say me Hi.</p>
            
            <form onSubmit={handleSubmit(onSubmit)} className="contact-form">
              <div className="form-row">
                <div className="form-group">
                  <label htmlFor="name">Name</label>
                  <input
                    type="text"
                    id="name"
                    placeholder="이태호"
                    {...register('name', { required: 'Name is required' })}
                    className={errors.name ? 'error' : ''}
                  />
                  {errors.name && <span className="error-message">{errors.name.message}</span>}
                </div>
                
                <div className="form-group">
                  <label htmlFor="email">Your email</label>
                  <input
                    type="email"
                    id="email"
                    placeholder="grayhat3400@gmail.com"
                    {...register('email', { 
                      required: 'Email is required',
                      pattern: {
                        value: /^\S+@\S+$/i,
                        message: 'Please enter a valid email'
                      }
                    })}
                    className={errors.email ? 'error' : ''}
                  />
                  {errors.email && <span className="error-message">{errors.email.message}</span>}
                </div>
              </div>
              
              <div className="form-group">
                <label htmlFor="project">About Project</label>
                <textarea
                  id="project"
                  rows={6}
                  placeholder="I want to discuss about blockchain development, community building, or collaboration opportunities..."
                  {...register('project', { required: 'Project description is required' })}
                  className={errors.project ? 'error' : ''}
                />
                {errors.project && <span className="error-message">{errors.project.message}</span>}
              </div>
              
              <button 
                type="submit" 
                className="submit-btn"
                disabled={isSubmitting}
              >
                {isSubmitting ? 'Sending...' : 'Send Here'}
              </button>
            </form>
          </motion.div>
        </div>
      </section>

      {/* Social Links */}
      <section className="social-section">
        <div className="container">
          <motion.div
            className="social-content"
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
          >
            <div className="social-links">
              {socialLinks.map((link, index) => (
                <motion.a
                  key={index}
                  href={link.url}
                  className="social-link"
                  whileHover={{ scale: 1.1 }}
                  whileTap={{ scale: 0.95 }}
                >
                  <span className="social-icon">{link.icon}</span>
                  <span>{link.name}</span>
                </motion.a>
              ))}
            </div>
            <div className="brand-footer">
              <span>이태호</span>
            </div>
          </motion.div>
        </div>
      </section>
    </div>
  );
};

export default Contact;